<template>
  <!-- 看板数据卡片，这个卡片必须固定尺寸，也就是不能被元素改变大小 -->
  <div class="data-card" ref="canvasContainer">
    <canvas class="canvas" ref="canvasSelf"/>
    <div class="card" :style="{'background-image': `radial-gradient(transparent, ${gradientColor})`, '--line-color': `${lineColor}`, '--stock-color': `${stockColor}`}">
      <div class="card-title" v-if="showTitle">
        <div class="title-left">
          <span class="info-tag"></span>
          <span class="info-tag"></span>
          <span class="info-tag"></span>
          <span class="label"><slot name="label">{{label}}</slot></span>
        </div>
        <div class="title-right">
          <slot name="desc"/>
        </div>
      </div>
      <div class="card-content">
        <div>
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import canvasUtil from "@/util/canvasUtil";

export default {
  props: {
    label: {default: ""},
    // 颜色，使用hex标准
    lineColor: {default: "#22ffed"},
    // type只有两种，common和simple
    type: {default: "common"},
    stockColor: {default: "#22ffed"},
    showTitle: {default: true},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "BDC",
  components: {
  },
  data() {
    return {
      gradientColor: "transparent",
    };
  },
  created() {
    // hex颜色转rgb颜色
    let hex = this.lineColor.replace("#", "");
    let h1 = hex.substring(0, 2), h2 = hex.substring(2,4), h3 = hex.substring(4, 6);
    this.gradientColor = `rgba(${parseInt(h1, 16)},${parseInt(h2, 16)},${parseInt(h3, 16)}, 0.1)`;
  },
  mounted() {
    this.$nextTick().then(() => {
     this.init();
    });
    window.addEventListener("resize", this.init);
  },
  unmounted() {
    window.removeEventListener("resize", this.init);
  },
  methods: {
    init() {
      let container = this.$refs.canvasContainer;
      let canvas = this.$refs.canvasSelf;
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;
      let width = container.clientWidth;
      let height = container.clientHeight;
      let ctx = canvas.getContext('2d');
      ctx.clearRect(0,0,width, height); // 清空图形
      if (this.type === "common") {
        this.backgroundCommon(ctx, width, height);
      } else {
        this.backgroundSimple(ctx, width, height);
      }
    },
    backgroundCommon(ctx, width, height) {
      let arrTop = [
        [0, 20],
        [0, 10],
        [10, 0],
        [width - 210, 0],
        [width - 205, 8],
        [width - 110, 8],
        [width - 105, 0],
        [width - 10, 0],
        [width, 10],
        [width, 20]
      ];
      canvasUtil.drawPolyline(ctx, arrTop, 1, this.lineColor);
      let pointTop = [
          [width - 208, 0],
          [width - 107, 0],
          [width - 112, 5],
          [width - 203, 5]
      ];
      canvasUtil.drawPolygon(ctx, pointTop, `transparent`, this.stockColor);


      let arrBottom = [
        [0, height - 20],
        [0, height - 10],
        [10, height],
        [width - 143, height],
        [width - 135, height - 8],
        [width - 58, height - 8],
        [width - 50, height],
        [width - 10, height],
        [width, height - 10],
        [width, height - 20]
      ];
      canvasUtil.drawPolyline(ctx, arrBottom, 1,  this.lineColor);
      let regons = [
        [[width - 133, height - 5], [width - 121, height - 5], [width - 126, height], [width - 138, height]],
        [[width - 115, height - 5], [width - 103, height - 5], [width - 108, height], [width - 120, height]],
        [[width - 97, height - 5], [width - 95, height - 5], [width - 90, height], [width - 102, height]],
        [[width - 89, height - 5], [width - 77, height - 5], [width - 72, height], [width - 84, height]],
        [[width - 71, height - 5], [width - 59, height - 5], [width - 54, height], [width - 66, height]],
      ];
      for (let i = 0; i < regons.length; i++) {
        canvasUtil.drawPolygon(ctx, regons[i], `transparent`, this.stockColor);
      }
    },
    backgroundSimple(ctx, width, height) {
      let arrTop = [
        [0, 20],
        [0, 10],
        [10, 0],
        [width - 10, 0],
        [width, 10],
        [width, 20]
      ];
      canvasUtil.drawPolyline(ctx, arrTop, 1, this.lineColor);

      let arrBottom = [
        [0, height - 20],
        [0, height - 10],
        [10, height],
        [width - 10, height],
        [width, height - 10],
        [width, height - 20]
      ];
      canvasUtil.drawPolyline(ctx, arrBottom, 1, this.lineColor);

    }
  }
};
</script>

<style lang="scss" scoped>
.data-card{
  display: block;
  position: relative;
  box-sizing: border-box;
  padding: 2px;
  height: 100%;
  .canvas{
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
  }
  .card{
    padding: 20px 20px 10px;
    height: 100%;
    box-sizing: border-box;
    clip-path: polygon(10px 0, calc(100% - 10px) 0, 100% 10px, 100% calc(100% - 10px), calc(100% - 10px) 100%, 10px 100%, 0 calc(100% - 10px), 0 10px);
    display: flex;
    flex-direction: column;
    .card-title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .title-left{
        .info-tag{
          margin-right: 5px;
          display: inline-block;
          width: 8px;
          height: 10px;
          background: var(--stock-color);
        }
        .label{
          margin-left: 10px;
          color: #FFF;
        }
      }
      .title-right{

      }
    }
    .card-content{
      flex: 1;
      height: 100px;
      overflow: hidden;
      >div{
        height: 100%;
        overflow: auto;
      }
    }
  }
}
</style>